export default {
  isUserReadyToLink() {
    return !!this.userId && !!this.role;
  },
  isAddFormVisible() { return this.$store.state.linkUser.isAddFormVisible; },
  isResponseMessageVisible() {
    return this.$store.state.linkUser.isResponseMessageVisible;
  },
  userType() { return this.$store.state.linkUser.userType; },
  getResponseMessage() {
    const displayName = this.$store.state.linkUser.latestAssociationDisplayName || 'user';
    switch (this.$store.state.linkUser.latestAssociationStatusCode) {
      case 201:
      case 200:
        return `Successfully added ${displayName}`;
      case 304:
        return `${displayName} is already associated with this hospital`;
      case 400:
        return this.$store.state.linkUser.latestAssociationMessage;
      default:
        return '';
    }
  },
};



// WEBPACK FOOTER //
// ./src/components/OrganizationAdminLinkScreen/organizationAdminLinkScreen.computed.js